import { SmppConnectionItem } from "@/store/settings/smpp_connections/types";
import { ServiceProviderFilter } from "@/store/settings/service_providers/types";

export interface IncomingTariffsState {
  incomingTariffs: IncomingTariffsItem[];
}

export class IncomingTariffsFilterParams {
  service_number?: string = undefined;
  service_provider?: string = undefined;
  partner?: string = undefined;
  broker_account?: string = undefined;
  priority?: number = undefined;
}

export interface IncomingTariffsItem {
  id: number;
  service_number: string;
  service_providers: string;
  regexp: string;
  partner: string;
  broker_account: string;
  priority: number;
}

export class IncomingTariffsItemInfo {
  id: number | null;
  service_number: string | null;
  regexp: string | null;
  partner: string | null;
  partner_id: number | null;
  broker_account: string | null;
  broker_account_id: number | null;
  priority: number | null;
  provider_modules: ProviderModule[] | Provider[];

  constructor() {
    this.id = null;
    this.service_number = null;
    this.regexp = null;
    this.partner = null;
    this.partner_id = null;
    this.broker_account = null;
    this.broker_account_id = null;
    this.priority = null;
    this.provider_modules = [];
  }

  setProviderModules(connections: SmppConnectionItem[]): void {
    let providerModule: ProviderModule;
    connections.forEach((connection: SmppConnectionItem) => {
      providerModule = new ProviderModule();
      providerModule.module = connection.name;
      providerModule.module_id = connection.id ?? null;
      providerModule.service_provider = connection.service_provider ?? null;
      providerModule.service_provider_id =
        connection.service_provider_id ?? null;
      this.provider_modules.push(providerModule);
    });
  }
}

export class ProviderModule {
  service_provider_id: number | null;
  service_provider?: string | null;
  module_id?: number | null;
  module?: string | null;
  is_allowed: boolean;

  constructor() {
    this.service_provider_id = null;
    this.service_provider = null;
    this.module_id = null;
    this.module = null;
    this.is_allowed = false;
  }
}

export class Provider {
  service_provider_id: number | null;
  service_provider?: string | null;
  service_provider_name?: string | null;
  is_allowed: boolean;

  constructor() {
    this.service_provider_id = null;
    this.service_provider = null;
    this.is_allowed = false;
  }
}
